module.exports = __webpack_public_path__ + "img/LAKETAIApparel.b025308f.jpg";